<iframe width="100%" height="800px" frameBorder="0" [src]="urlSafe" scrolling="no"></iframe>

